import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

export const StyledDiv = styled.div`
  color: #6f6f6f;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 21px;
`;
